import $ from 'jquery';
import 'jquery-lazy';
import { loadScriptOnDemand, SCRIPT_ON_DEMAND_NAME } from 'modules/lazy/script-on-demand';
import initSearch from 'modules/search';
import 'modules/state-search';
import 'styleguide/abtests/ab553';

const initLazy = () => {
  $.Lazy(SCRIPT_ON_DEMAND_NAME, loadScriptOnDemand);

  const lazyObjDefault = {
    effect: 'fadeIn',
    effectTime: 500,
    threshold: 0
  };

  const lazyObjHPGramOptions = {
    beforeLoad: function (element) {
      if($(element).attr('id') === 'likeshop-carousel') {
        $('.js-gram-preload-skeleton').hide();
      }
    }
  };

  const lazyObjGram = $.extend(lazyObjDefault, lazyObjHPGramOptions);

  $('.js-lazy-image').lazy(lazyObjDefault);

  $('.js-gram-lazy').lazy(lazyObjGram)

};

initLazy();

$(document).ready(() => {
  initSearch();
  $('.js-state-search').stateSearch();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/deferred-chrome/index.js